import React, { useEffect, useRef, useState } from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchColorsByTextiles} from "../../../../../../reduxLib/colorsLib";
import {uploadProductImages} from "../../../../../../Utilities/uploadHelperProd";
import {fetchPcategories} from "../../../../../../reduxLib/pcategoriesLib";
import {CreateProduct, fetchProductByID} from "../../../../../../reduxLib/productLib";
import {createFile} from "../../../../../../reduxLib/filesPhLib";

// ✅ Βάλε τα σωστά imports από τα libs σας
// import uploadProductImages from "....";
// import { createFile } from "...../reduxLib/filesLib";
// import { createProduct } from "...../reduxLib/productLib";
// import { fetchColorsByTextiles } from "...../reduxLib/pcolorsLib";

export default function AddProductModal2({ open, setOpen, categories = [] }) {

    const sizeMap = {
        "5": "Small",
        "4": "Medium",
        "3": "Large",
    };

    const dispatch = useDispatch();

    const fileInputRef = useRef(null);

    const [selectedFiles, setSelectedFiles] = useState([]);
    const [saving, setSaving] = useState(false);
    const [err, setErr] = useState("");

    //categories fetch
    const [categoryOptions, setCategoryOptions] = useState([]);
    const catstate=useSelector((state)=> state.categoryreducer.state);
    categories= useSelector((state)=> state.categoryreducer.pcategoriesList);


    // textiles -> colors
    const [textilesValue, setTextilesValue] = useState("");
    const [colorsOptions, setColorsOptions] = useState([]); // [{id,name,hex?}]
    const [selectedColorIds, setSelectedColorIds] = useState([]); // unlimited

    // reset όταν ανοίγει/κλείνει
    useEffect(() => {
        if (!open) {
            setSelectedFiles([]);
            setSaving(false);
            setErr("");
            setTextilesValue("");
            setColorsOptions([]);
            setSelectedColorIds([]);
        }
    }, [open]);

    useEffect(()=>{

        if(!categories || categories.length === 0) {
            // Fetch the event by ID when the component mounts or when the id changes
            dispatch(fetchPcategories()).then((action) => {
                // Once the action is fulfilled, set the eventprofile state
                if (action.payload) {
                    setCategoryOptions(action.payload);
                    console.log("playload ", action.payload);
                    console.log("playload E", categoryOptions);
                }
            });
        }
        else {
            //let f=events.filter((event) => event.ownerid === id);
            // If the event data is already available, set the eventprofile state

            setCategoryOptions(categories);
            console.log("not disp ",categories);
        }
    }, [dispatch,catstate]);

    // load colors when textiles changes
    useEffect(() => {
        let cancelled = false;

        async function loadColors() {
            setErr("");
            if (!textilesValue) {
                setColorsOptions([]);
                setSelectedColorIds([]);
                return;
            }

            try {
                // ✅ thunk που επιστρέφει list colors με βάση textiles
                const action = await dispatch(fetchColorsByTextiles(textilesValue));
                const raw = action?.payload ?? [];

                const normalized = Array.isArray(raw)
                    ? raw.map((c) => ({
                        id: Number(c.pcid),
                        name: c.colorName ?? c.ColorName ?? "",
                        hex: c.hexColor ?? c.HexColor ?? null,
                    }))
                    : [];
                //console.log("NORMALIZED COLORS:", normalized);
                console.log("cansel", cancelled);

                if (cancelled) return;

                setColorsOptions(normalized);

                // κράτα selected που υπάρχουν ακόμα στο νέο textiles
                const allowed = new Set(normalized.map((c) => Number(c.id)));
                setSelectedColorIds((prev) => prev.filter((id) => allowed.has(id)));

            } catch (e) {
                if (!cancelled) setErr(e?.message || "Failed to load colors");
            }
        }

        loadColors();
        return () => {
            cancelled = true;
        };
    }, [textilesValue, dispatch]);

    const toggleColor = (id) => {
        const n = Number(id);
        setSelectedColorIds((prev) =>
            prev.includes(n) ? prev.filter((x) => x !== n) : [...prev, n]
        );
    };

    const onPickFiles = (e) => {
        const files = Array.from(e.target.files || []);
        setSelectedFiles(files);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErr("");
        setSaving(true);

        try {
            const form = new FormData(e.target);

            // --------- primitives/enums (ταιριάζουν με productCreator DTO)
            const name = (form.get("name") || "").toString().trim();
            const Description = (form.get("Description") || "").toString();
            const details = (form.get("details") || "").toString();

            const categoryRelId = Number(form.get("categoryRelId") || 0);

            // long Price -> cents
            const euro = Number(form.get("Price") || 0);
            const Price = Math.round(euro);//Math.round(euro * 100);

            const ConstructionEffortDays = Number(form.get("ConstructionEffortDays") || 0);

            const Dimentions = (form.get("Dimentions") || "").toString();
            const Size = (form.get("Size") || "").toString();

            const productSize = (form.get("productSize") || "").toString() || null;
            const plexis = (form.get("plexis") || "").toString() || null;
            const textiles = textilesValue || null;
            const closingTextiles = (form.get("closingTextiles") || "").toString() || null;

            // --------- 1) upload images -> urls[]
            let uploadedUrls = [];
            //console.log("SELECTED FILES:", selectedFiles);
            if (selectedFiles.length > 0) {
                uploadedUrls = await uploadProductImages(name || "product", selectedFiles);
                if (!Array.isArray(uploadedUrls)) uploadedUrls = [];
            }
            const productFilesIds = [];


            // --------- 3) productCreator payload
            const productCreator = {
                name,
                Description,
                details,
                Price,
                categoryRelId,
                Rating: 0,
                // DateAdded: new Date(), // καλύτερα server-side
                colorsIds: selectedColorIds, // unlimited
                Dimentions,
                productSize,
                Size,
                plexis,
                textiles,
                closingTextiles,
                ConstructionEffortDays,
                productFilesIds,
                isPopular: false,
            };
            console.log("PRODUCT TO CREATE:", productCreator);

            //test block
            await dispatch(fetchProductByID(8)).then((action) => {
                if (action.error) {
                    throw new Error(action.error.message || "Fetch product failed");
                }
                if(action.payload) {
                    console.log("Fetched product:", action.payload);
                    console.log("fets id ", action.payload.productID);
                }
            })

            // --------- 4) create product
            const product=await dispatch(CreateProduct(productCreator)).then((action) => {
                if (action.error) {
                    throw new Error(action.error.message || "Create product failed");
                }
                if(action.payload) {
                    console.log("Created product");
                }
            });
            //relating files with product
            const productId =
                product.payload?.productID ??
                product.payload?.id ??
                product.payload;

            for (let i = 0; i < uploadedUrls.length; i++) {
                const url = uploadedUrls[i];
                if (!url) continue;

                const filesCreator = {
                    Name: `${name}-${i + 1}`,
                    FileLocation: url,
                    DateCreated: new Date(),
                    fileType: "PRODUCT_IMAGE",
                    productRelId: Number(productId), // δεν υπάρχει ακόμα product, άστο 0 (ή ό,τι δέχεται backend)
                };

                const action = await dispatch(createFile(filesCreator));
                const newId= action?.payload?.id ?? action?.payload?.fid ?? action?.payload;
                if (newId != null) productFilesIds.push(Number(newId));
            }

            setOpen(false);
        } catch (ex) {
            setErr(ex?.message || "Create product failed");
        } finally {
            setSaving(false);
        }
    };
    const [SizeValue, setSizeValue] = useState("");

    const handleProductSizeChange = (e) => {
        const v = (e.target.value || "").toString();
        setSizeValue(sizeMap[v] ?? "");
    };

    if (!open) return null;

    return (
        <div
            className="modal fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            onClick={() => !saving && setOpen(false)}
        >
            <div
                className="bg-white rounded-lg p-8 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-serif font-bold text-custom-green">
                        Add New Product
                    </h2>
                    <button
                        onClick={() => !saving && setOpen(false)}
                        className="text-gray-400 hover:text-gray-600"
                        type="button"
                    >
                        <i className="fa-solid fa-times text-xl" />
                    </button>
                </div>

                {err && (
                    <div className="mb-4 p-3 rounded bg-red-50 text-red-700 text-sm border border-red-200">
                        {err}
                    </div>
                )}

                <form className="space-y-6" onSubmit={handleSubmit}>
                    {/* name + category */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Product Name *
                            </label>
                            <input
                                type="text"
                                name="name"
                                required
                                disabled={saving}
                                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Category *
                            </label>
                            <select
                                name="categoryRelId"
                                required
                                disabled={saving}
                                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                            >
                                <option value="">Select Category</option>
                                {categories.length > 0 ? (
                                    categories.map((c) => (
                                        <option key={c.categoryID ?? c.pid} value={c.categoryID ?? c.pid}>
                                            {c.name}
                                        </option>
                                    ))
                                ) : (
                                    <>
                                        <option value="-1">not found</option>
                                    </>
                                )}
                            </select>
                        </div>
                    </div>

                    {/* description */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Description *
                        </label>
                        <textarea
                            name="Description"
                            rows={3}
                            required
                            disabled={saving}
                            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                        />
                    </div>

                    {/* details */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Details
                        </label>
                        <textarea
                            name="details"
                            rows={4}
                            disabled={saving}
                            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                        />
                    </div>

                    {/* price + construction days */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Price (€) *
                            </label>
                            <input
                                type="number"
                                name="Price"
                                step="0.01"
                                required
                                disabled={saving}
                                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                            />
                            <p className="text-xs text-gray-500 mt-1">
                                Στέλνεται σε cents (long).
                            </p>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Construction Days
                            </label>
                            <input
                                type="number"
                                name="ConstructionEffortDays"
                                min="1"
                                disabled={saving}
                                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                            />
                        </div>
                    </div>

                    {/* dimensions + size */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Dimensions
                            </label>
                            <input
                                type="text"
                                name="Dimentions"
                                placeholder="e.g., 30x40x25 cm"
                                disabled={saving}
                                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                            />
                        </div>
                        {/* product size */}
                        {/* product size */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Product Size
                            </label>
                            <select
                                name="productSize"
                                disabled={saving}
                                onChange={handleProductSizeChange}
                                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                            >
                                <option value="">Select</option>
                                <option value="5">Small</option>
                                <option value="4">Medium</option>
                                <option value="3">Large</option>
                            </select>
                        </div>

                        {/* size (locked, derived from productSize) */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Size
                            </label>
                            <input
                                type="text"
                                value={SizeValue}
                                readOnly
                                disabled={saving}
                                className="w-full px-3 py-2 border rounded-lg bg-gray-100 text-gray-600"
                                placeholder="Auto from Product Size"
                            />

                            {/* IMPORTANT: αυτό είναι που διαβάζεις στο submit: form.get("Size") */}
                            <input type="hidden" name="Size" value={SizeValue} />
                        </div>
                    </div>

                    {/* special props */}
                    <div className="border-t pt-6">
                        <h3 className="text-lg font-medium text-gray-900 mb-4">
                            Special Properties
                        </h3>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {/* textiles (drives colors) */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Textiles
                                </label>
                                <select
                                    name="textiles"
                                    value={textilesValue}
                                    onChange={(e) => setTextilesValue(e.target.value)}
                                    disabled={saving}
                                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                                >
                                    <option value="">None</option>
                                    <option value="bambakero">bambakero</option>
                                    <option value="bambakeroLourex">bambakeroLourex</option>
                                    <option value="forte">forte</option>
                                </select>
                                <p className="text-xs text-gray-500 mt-1">
                                    Με βάση αυτό εμφανίζονται τα διαθέσιμα colors.
                                </p>
                            </div>

                            {/* colors (unlimited multi) */}
                            <div>
                                <div className="flex items-center justify-between mb-2">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Available Colors
                                    </label>
                                    <span className="text-xs text-gray-500">
                {selectedColorIds.length} selected
              </span>
                                </div>
                                {
                                    !textilesValue ? (
                                        <div className="text-sm text-gray-500 border rounded-lg p-4">
                                            Διάλεξε πρώτα <b>Textiles</b> για να εμφανιστούν χρώματα.
                                        </div>
                                    ) : (
                                        <div className="grid grid-cols-4 md:grid-cols-6 gap-3 max-h-48 overflow-y-auto p-2 border rounded-lg">
                                            {
                                                colorsOptions.map(
                                                    (c) => {
                                                        const id = Number(c.id);
                                                        const checked = selectedColorIds.includes(id);

                                                        return (
                                                            <button
                                                                key={id}
                                                                type="button"
                                                                onClick={() => toggleColor(id)}
                                                                disabled={saving}
                                                                className="flex flex-col items-center space-y-1 cursor-pointer group"
                                                                title={c.name}
                                                            >
                                                                <div
                                                                    className={`w-12 h-12 rounded-lg border-2 transition-all group-hover:scale-105 ${
                                                                        checked
                                                                            ? "border-custom-green ring-2 ring-custom-green"
                                                                            : "border-gray-300"
                                                                    }`}
                                                                    style={c.hex ? { backgroundColor: c.hex } : undefined}
                                                                />
                                                                <span className="text-xs text-center">{c.name}</span>
                                                            </button>
                                                        );
                                                    }
                                                )
                                            }
                                        </div>
                                    )}
                            </div>

                            {/* plexis */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Plexis
                                </label>
                                <select
                                    name="plexis"
                                    disabled={saving}
                                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                                >
                                    <option value="">None</option>
                                    <option value="basic">basic</option>
                                    <option value="kagelaki">kagelaki</option>
                                    <option value="grammh">grammh</option>
                                    <option value="vafla">vafla</option>
                                </select>
                            </div>

                            {/* closing textiles */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Closing Textiles
                                </label>
                                <select
                                    name="closingTextiles"
                                    disabled={saving}
                                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-custom-green focus:border-transparent"
                                >
                                    <option value="None">Δεν έχει</option>
                                    <option value="SIMPLE">Απλό</option>
                                    <option value="CABOURAS">Καβούρας</option>
                                    <option value="AXTIDA">Αχτίδα</option>
                                    <option value="TSOUREKI">Τσουρέκι</option>
                                </select>
                            </div>

                        </div>
                    </div>



                    {/* images */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Product Images
                        </label>

                        <button
                            type="button"
                            className="w-full border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 disabled:opacity-60"
                            onClick={() => fileInputRef.current?.click()}
                            disabled={saving}
                        >
                            <i className="fa-solid fa-cloud-upload-alt text-3xl text-gray-400 mb-2" />
                            <p className="text-gray-600">
                                {saving ? "Saving..." : "Click to upload images"}
                            </p>
                            <p className="text-xs text-gray-500 mt-1">
                                Upload multiple images for your product
                            </p>
                        </button>

                        <input
                            ref={fileInputRef}
                            type="file"
                            multiple
                            accept="image/*"
                            className="hidden"
                            onChange={onPickFiles}
                            disabled={saving}
                        />

                        {selectedFiles.length > 0 && (
                            <div className="mt-3 text-sm text-gray-600">
                                Selected: {selectedFiles.map((f) => f.name).join(", ")}
                            </div>
                        )}
                    </div>

                    <div className="flex justify-end space-x-4 pt-4">
                        <button
                            type="button"
                            onClick={() => !saving && setOpen(false)}
                            className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 disabled:opacity-60"
                            disabled={saving}
                        >
                            Cancel
                        </button>

                        <button
                            type="submit"
                            className="px-6 py-2 bg-custom-green text-white rounded-lg hover:bg-opacity-90 disabled:opacity-60"
                            disabled={saving}
                        >
                            {saving ? "Creating..." : "Add Product"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
